<template>
  <router-view />
</template>

<script>
export default {
  name: 'Applicant'
}
</script>

<style scoped>

</style>
